var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['basic-drawer', { hidden: _vm.hidden }],style:({ '--duration': `${_vm.duration}s` })},[_c('div',{staticClass:"drawer-box"},[_c('div',{staticClass:"drawer-box_header"},[_vm._t("header")],2),_c('div',{staticClass:"drawer-box_content"},[_vm._t("default")],2),_c('div',{staticClass:"drawer-box_footer"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }